import _ from "lodash"
import type { Meta } from "@/common/types/router"
import type { Variant } from "@/common/types/variant"
import type { UserType } from "@/common/types/user"

export const isValidUserType = (meta?: Meta, userType: UserType): boolean => {
    if (!meta) {
        return true
    }

    if (
        (meta.includeUserTypes && !_.includes(meta.includeUserTypes, userType)) ||
        (meta.excludeUserTypes && _.includes(meta.excludeUserTypes, userType))
    ) {
        return false
    }

    return true
}

export const isValidRoute = (meta?: Meta, variant: Variant, isEvent: boolean): boolean => {
    if (!meta) {
        return true
    }

    if (
        (meta.includeVariants && !_.includes(meta.includeVariants, variant)) ||
        (meta.excludeVariants && _.includes(meta.excludeVariants, variant))
    ) {
        return false
    }

    if (meta.isEvent !== undefined && isEvent !== meta.isEvent) {
        return false
    }

    return true
}
